import React from 'react';
import './Skills.css';

const Skills = () => {
  return (
    <div>
      <section className='skills' id='skills'>
        <h2 className='heading'>Experienced <span>Technologies</span></h2>

        <div className='skills-container'> 
            <div className='skills-box-highlight'>             
                <div className='skills-icon'>               
                    <img src='./skills-icons/react.png' alt='React.js'></img>             
                </div>             
                <h3>React.js</h3>           
            </div>    

            <div className='skills-box-highlight'>             
                <div className='skills-icon'>               
                    <img src='./skills-icons/next.png' alt='Next.js'></img>             
                </div>             
                <h3>Next.js</h3>           
            </div>

            <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/nodejs.png' alt='Node.js'></img>             
              </div>             
              <h3>Node.js</h3>           
            </div> 

            <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/mongodb.png' alt='MongoDB'></img>             
              </div>             
              <h3>MongoDB</h3>           
            </div> 

            <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/expressjs.png' alt='Express.js'></img>             
              </div>             
              <h3>Express.js</h3>           
            </div>

            <div className='skills-box-highlight'>             
                <div className='skills-icon'>               
                    <img src='./skills-icons/aws.png' alt='AWS'></img>             
                </div>             
                <h3>AWS</h3>           
            </div> 

            <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/springboot.png' alt='Springboot'></img>             
              </div>             
              <h3>Springboot</h3>           
            </div> 
          {/* <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/django.png' alt='Django'></img>             
              </div>             
              <h3>Django</h3>           
          </div>  */}
          <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/laravel.png' alt='Laravel'></img>             
              </div>             
              <h3>Laravel</h3>           
          </div>            
          {/* <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/expressjs.png' alt='Express.js'></img>             
              </div>             
              <h3>Express.js</h3>           
          </div>             */}
          {/* <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/nodejs.png' alt='Node.js'></img>             
              </div>             
              <h3>Node.js</h3>           
          </div>             */}
          <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/python.png' alt='Python'></img>             
              </div>             
              <h3>Python</h3>           
          </div>  

          <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/javascript.png' alt='javascript'></img>             
              </div>             
              <h3>Java Script</h3>           
          </div>             
                    
          <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/java.png' alt='Java'></img>             
              </div>             
              <h3>Java</h3>           
          </div>            
          <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/php.png' alt='PHP'></img>             
              </div>             
              <h3>PHP</h3>           
          </div>            
          <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/html5.png' alt='HTML'></img>             
              </div>             
              <h3>HTML</h3>           
          </div>            
          <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/css3.png' alt='CSS'></img>             
              </div>             
              <h3>CSS</h3>           
          </div>            
          <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/mysql.png' alt='MySQL'></img>             
              </div>             
              <h3>MySQL</h3>           
          </div>   
          <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/postman.png' alt='Postman'></img>             
              </div>             
              <h3>Postman</h3>           
          </div>  
          <div className='skills-box-highlight'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/git.png' alt='Git'></img>             
              </div>             
              <h3>Git</h3>           
          </div>           
          {/* <div className='skills-box'>             
              <div className='skills-icon'>               
                  <img src='./skills-icons/mongodb.png' alt='MongoDB'></img>             
              </div>             
              <h3>MongoDB</h3>           
          </div>          */}
      </div>

      </section>
    </div>
  );
}

export default Skills;
